import React from "react";
import classes from "./style.module.css";
import { Checkbox } from "@mui/material";
import { baseURL } from "../../../../../assets/constants/baseUrl";

export default function ImageTestElement({
  src,
  text,
  index,
  handleSelect,
  selected,
  wrong,
}) {
  const bgClass = [
    classes.blueBg,
    classes.lightBlue,
    classes.pinkBg,
    classes.purpleBg,
  ];
  return (
    <div
      className={`${classes.imageTestElement} ${bgClass[index]} ${
        selected ? classes.selected : ""
      }`}
      onClick={() => {
        if (!wrong) {
          handleSelect(!selected);
        }
      }}
      style={{ opacity: wrong ? 0.5 : 1 }}
    >
      <div className={classes.checkBoxContainer}>
        <Checkbox
          checked={selected}
          onChange={(e) => {
            if (!wrong) {
              handleSelect(e.target.checked);
            }
          }}
          sx={{
            padding: 0,
            color: "var(--secondary475)",
            "&.Mui-checked": {
              color: "var(--secondary475)",
            },
          }}
        />
      </div>
      <img
        crossOrigin="anonymous"
        src={`${baseURL}file/get/${src}`}
        alt="imageTestElement"
      />
      <div className={classes.textContainer}>{text}</div>
    </div>
  );
}
